import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UserBackendService } from '@app/user/user-core/services/user-backend.service';
import { TradeItemDto } from '@app/user/marks/marks-store/marks-types';
import { SearchItemPartyParams } from '@helper/abstraction/filter';
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-search-product-popup',
    templateUrl: './search-product-popup.component.html',
    styleUrls: ['./search-product-popup.component.scss']
})
export class SearchProductPopupComponent implements OnInit {
	public partyId?: number;
    public productSelectBoxOption = {
        getData$: (selectBoxState: SearchItemPartyParams): Observable<SearchItemPartyParams[]> => {
            let data = {
                ...selectBoxState,
                partyId: this.partyId
            };
            if (!["TK"].includes(this.env.project)) {
                delete data.partyId;
            }
            return this.userBackendService.epass.searchProductsList.post$(data);
        },
        mapData: (data: TradeItemDto[]): TradeItemDto[] => data,
    };
    private env = environment;

    constructor(
        public config: DynamicDialogConfig,
        public ref: DynamicDialogRef,
        private userBackendService: UserBackendService,
    ) { }

    public ngOnInit(): void {
		this.setData();
	}

    public close(product?: TradeItemDto): void {
		this.ref.close(product);
	}

    private setData(): void {
		this.config.width = "820px";
		this.config.header = "Поиск товара";
    	this.config.height = "630px";
        this.partyId = this.config?.data?.partyId;
	}
}
